import { Popover } from 'antd5';
import styled from 'styled-components';

import { Theme } from 'utils/color/horizonTheme';

export const LegendPopover = styled(Popover)<{
  $isScrolledToTop: boolean;
  $isScrolledToBottom: boolean;
}>`
  .ant-popover-content {
    width: max-content;

    .ant-popover-inner {
      background: ${({ theme }) =>
        theme.themeName === Theme.Dark
          ? theme.tertiaryBackgroundColor
          : theme.secondaryBackgroundColor};
      padding: 0;

      ${({ $isScrolledToTop, theme }) =>
        !$isScrolledToTop &&
        `
            -webkit-box-shadow: inset 0px 5px 5px -3px ${theme.lightShadow};
            -moz-box-shadow: inset 0px 5px 5px -3px ${theme.lightShadow};
            box-shadow: inset 0px 5px 5px -3px ${theme.lightShadow};
          `}

      .ant-popover-inner-content {
        max-height: 400px;
        overflow-y: auto;
        padding: 0;

        > div {
          ul {
            color: ${({ theme }) => theme.headerColor} !important;
            list-style-type: none;
            margin-bottom: 0;
            padding: 1rem;

            span {
              margin-left: 0.5rem;
            }
          }
        }

        ${({ $isScrolledToBottom, theme }) =>
          !$isScrolledToBottom &&
          `
          -webkit-box-shadow: inset 0px -5px 5px -3px ${theme.lightShadow} !important;
          -moz-box-shadow: inset 0px -5px 5px -3px ${theme.lightShadow} !important;
          box-shadow: inset 0px -5px 5px -3px ${theme.lightShadow} !important;
        `}
      }
    }
  }
`;

export const DamageCountSpan = styled.span`
  color: ${({ theme }) => theme.secondaryTextColor};
  margin-left: 0 !important;
`;
